import { render, staticRenderFns } from "./ScrollbarWatcher.vue?vue&type=template&id=08b71756&scoped=true"
import script from "./ScrollbarWatcher.vue?vue&type=script&lang=js"
export * from "./ScrollbarWatcher.vue?vue&type=script&lang=js"
import style0 from "./ScrollbarWatcher.vue?vue&type=style&index=0&id=08b71756&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b71756",
  null
  
)

export default component.exports